import React from 'react'
import Notifications from '../modules/Notifications'
import MessagesModule from '../modules/MessagesModule'
import globals from '../globals'

class Messages extends React.Component {
    componentDidMount () {
        globals.delayedAnimatePageIn(this.container)
    }

    render () {
        return (
            <div ref={(el) => this.container = el} style={{ opacity: 0 }}>
                <Notifications icon='icon-email.svg'>
                    <p>Any <span className='bold'>SMS or emails</span> that we've sent you, you'll find here.</p>
                </Notifications>
                <MessagesModule />
            </div>
        )
    }
}

export default Messages



// WEBPACK FOOTER //
// ./resources/js/pages/Messages.js